/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/10/19
 * Time: 10:53 AM
 */
import * as actionTypes from './actionTypes'

export const imageUploaderHandler = (data) => {
  return {
    type: actionTypes.IMAGE_UPLOADER,
    value: data
  }
};



